import { render, staticRenderFns } from "./PedalMeSettings.vue?vue&type=template&id=1343d922"
import script from "./PedalMeSettings.vue?vue&type=script&lang=js"
export * from "./PedalMeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports